/**
 * @file: useVoiceFeatures.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { StoreFeature } from '@euler/model/enum';
import { Platform } from 'react-native';

/**
 * Whether the current store has voice input and voice synthesis, a trial
 * included.
 *
 * Voice input (mic recording) is force-disabled on web — the recording
 * pipeline isn't reliable there yet — so callers that gate UI on
 * `isVoiceInputEnabled` automatically hide the mic on web. Voice
 * synthesis (playback) still works cross-platform.
 */
export const useVoiceFeatures = () => {
  const voiceInput = useStoreFeature(StoreFeature.VoiceInput).enabled;
  const voiceSynthesis = useStoreFeature(StoreFeature.VoiceSynthesis).enabled;
  return {
    isVoiceInputEnabled: voiceInput && Platform.OS !== 'web',
    /**
     * Speech-to-text into a text box. Unlike recorded voice messages it
     * works on web too: the browser records WAV for the recognizer.
     */
    isDictationEnabled: voiceInput,
    isVoiceSynthesisEnabled: voiceSynthesis,
  };
};
